import { render, staticRenderFns } from "./activity-video.vue?vue&type=template&id=2cf9c8ed&scoped=true&"
import script from "./activity-video.vue?vue&type=script&lang=js&"
export * from "./activity-video.vue?vue&type=script&lang=js&"
import style0 from "./activity-video.vue?vue&type=style&index=0&id=2cf9c8ed&prod&lang=less&scoped=true&"
import style1 from "./activity-video.vue?vue&type=style&index=1&id=2cf9c8ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf9c8ed",
  null
  
)

export default component.exports